import { NSARouterMakerResult } from "namirasoft-account-react";
import { FilterItem, FilterItemOperator } from "namirasoft-core";
import { AccountRow, CompanyInputRow, CompanyRow, NamirasoftERPMetaDatabase } from "namirasoft-erp";
import { NSBox, NSBoxBoolean, NSBoxEntity, NSBoxString, NSBoxTextArea, NSColumn } from "namirasoft-site-react";
import { Component, createRef } from "react";
import { ErpEntities } from "../ErpEntities";
import { ErpLayout } from '../ErpLayout';
import { ErpRouterProps } from "../ErpRouterProps";
import { ErpScopeMode } from "../ErpScope";

interface Props extends NSARouterMakerResult, ErpRouterProps { isEdit: boolean; }

interface State { companyId: string | null; }

export default class CompanyEditPage extends Component<Props, State>
{
    override state: State = { companyId: null };

    Name = createRef<NSBoxString>();
    Description = createRef<NSBoxTextArea>();
    Enabled = createRef<NSBoxBoolean>();
    CurrentYearPLAccount = createRef<NSBoxEntity<AccountRow>>();
    RetainedEarningsAccount = createRef<NSBoxEntity<AccountRow>>();

    override render()
    {
        let db = new NamirasoftERPMetaDatabase(this.props.account.token_manager, console.error);

        return (
            <ErpLayout<CompanyRow, CompanyInputRow>
                {...this.props}
                mode={ErpScopeMode.None}
                pages={{
                    entity: ErpEntities.company(this.props),
                    edit: {
                        ...this.props,
                        ui: {
                            tab_page_edit: {
                                ui: {
                                    extra_tabs: [
                                        {
                                            title: "Financial",
                                            clicked: false,
                                            getContent: () => (
                                                <NSColumn>
                                                    <NSBoxEntity<AccountRow>
                                                        ref={this.CurrentYearPLAccount} title="Current Year P/L Account" info={{ link: "https://namirasoft.com/erp/console-guide/company/#field-current-year-pl-account" }} required={false} multiple={false}
                                                        table_name="account" table={db.tables.account}
                                                        list={(filters, page, size, sorts) =>
                                                        {
                                                            let f: FilterItem[] = filters ? [...filters] : [];
                                                            let companyId = this.state.companyId;
                                                            if (companyId)
                                                                f.push(new FilterItem(db.tables.account, db.tables.account.columns.company_id, false, FilterItemOperator.all.equals, companyId));
                                                            f.push(new FilterItem(db.tables.account, db.tables.account.columns.enabled, false, FilterItemOperator.all.equals, "1"));
                                                            f.push(new FilterItem(db.tables.account, db.tables.account.columns.is_group, false, FilterItemOperator.all.equals, "0"));
                                                            return this.props.servers.erp.account.List(f, page, size, sorts, null);
                                                        }}
                                                        getValue={(item) => item.id} getTitle={(item) => item.name} getSort={() => null}
                                                        style={{ width: NSBox.width.double }}
                                                    />
                                                    <NSBoxEntity<AccountRow>
                                                        ref={this.RetainedEarningsAccount} title="Retained Earnings Account" info={{ link: "https://namirasoft.com/erp/console-guide/company/#field-retained-earnings-account" }} required={false} multiple={false}
                                                        table_name="account" table={db.tables.account}
                                                        list={(filters, page, size, sorts) =>
                                                        {
                                                            let f: FilterItem[] = filters ? [...filters] : [];
                                                            let companyId = this.state.companyId;
                                                            if (companyId)
                                                                f.push(new FilterItem(db.tables.account, db.tables.account.columns.company_id, false, FilterItemOperator.all.equals, companyId));
                                                            f.push(new FilterItem(db.tables.account, db.tables.account.columns.enabled, false, FilterItemOperator.all.equals, "1"));
                                                            f.push(new FilterItem(db.tables.account, db.tables.account.columns.is_group, false, FilterItemOperator.all.equals, "0"));
                                                            return this.props.servers.erp.account.List(f, page, size, sorts, null);
                                                        }}
                                                        getValue={(item) => item.id} getTitle={(item) => item.name} getSort={() => null}
                                                        style={{ width: NSBox.width.double }}
                                                    />
                                                </NSColumn>
                                            ),
                                        },
                                    ],
                                },
                                editor: {
                                    getInputRow: (): CompanyInputRow => ({
                                        name: this.Name.current?.getValue() ?? "",
                                        description: this.Description.current?.getValue() ?? null,
                                        enabled: this.Enabled.current?.getValueBool() ?? true,
                                        current_year_pl_account_id: this.CurrentYearPLAccount.current?.getValueOne(false) ?? null,
                                        retained_earnings_account_id: this.RetainedEarningsAccount.current?.getValueOne(false) ?? null,
                                        company_category: [],
                                        company_tag: [],
                                        company_field: [],
                                    }),
                                    setRow: (row: CompanyRow) =>
                                    {
                                        this.Name.current?.setValue(row.name);
                                        this.Description.current?.setValue(row.description);
                                        this.Enabled.current?.setValueBool(row.enabled);
                                        this.CurrentYearPLAccount.current?.setValueOne(row.current_year_pl_account_id);
                                        this.RetainedEarningsAccount.current?.setValueOne(row.retained_earnings_account_id);
                                        this.setState({ companyId: row.id });
                                    }
                                }
                            }
                        }
                    }
                }}
            >
                <NSColumn>
                    <NSBoxString ref={this.Name} required title="Name" info={{ link: "https://namirasoft.com/erp/console-guide/company/#field-name" }} style={{ width: NSBox.width.double }} />
                    <NSBoxTextArea ref={this.Description} required={false} title="Description" info={{ link: "https://namirasoft.com/erp/console-guide/company/#field-description" }} style={{ width: NSBox.width.double }} />
                    <NSBoxBoolean ref={this.Enabled} required checked={true} title="Enabled" info={{ link: "https://namirasoft.com/erp/console-guide/company/#field-enabled" }} style={{ width: NSBox.width.double }} />
                </NSColumn>
            </ErpLayout>
        );
    }
}